import DOMPurify from 'dompurify';

export const sanitizeSvg = (svg: string): string | null => {
  if (typeof window === 'undefined') return null;

  const clean = DOMPurify.sanitize(svg, { USE_PROFILES: { svg: true, svgFilters: true } }).trim();
  if (!clean || !/^<svg[\s>]/i.test(clean)) return null;

  return clean;
};
